import React from 'react';
import { Skeleton } from 'antd';
import SummaryCard from './SummaryCard';
import CaratPlanningItem from './Items/CaratPlanningItem';
import { F } from '@/utils/intl';
import { CaratPlanningModel } from '@/typings/models/CaratModel';
import { useCaratPlannings } from '@/components/ProjectDetails/useCaratPlannings';

export interface CaratPlanningsCardProps {
  leadId: string;
  /** Opens the drawer on one planning, with the project's full list beside it. */
  onSelect: (planning: CaratPlanningModel, plannings: CaratPlanningModel[]) => void;
  onShowAll: (plannings: CaratPlanningModel[]) => void;
}

/** How many plannings the card previews before deferring to the drawer. */
const PREVIEW_COUNT = 3;

/**
 * "Carat plannings" card in the right column of the lead details
 * (CLICKUP-86cb5zayy). Rendered only when the partner has the Deal Manager
 * module and the Carat app installed — the caller gates on both, this component
 * additionally hides itself while the lead has no plannings at all.
 */
const CaratPlanningsCard: React.FC<CaratPlanningsCardProps> = ({ leadId, onSelect, onShowAll }) => {
  const { plannings, loading } = useCaratPlannings(leadId);

  if (loading) return <Skeleton active paragraph={{ rows: 2 }} />;
  if (plannings.length === 0) return null;

  return (
    <SummaryCard
      title={<F id="entity.carat_planning.plural" defaultMessage="Carat plannings" />}
      count={plannings.length}
      onShowAll={() => onShowAll(plannings)}
    >
      {plannings.slice(0, PREVIEW_COUNT).map((planning) => (
        <CaratPlanningItem
          key={planning.id}
          planning={planning}
          onSelect={() => onSelect(planning, plannings)}
        />
      ))}
    </SummaryCard>
  );
};

export default CaratPlanningsCard;
